
export default function formatTime(time) {
    const oldTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:)([0-5]\d)$/) || [time];
    const hours = oldTime[1] % 12 || 12;
    const minutes = oldTime[3] > 0 ? `:${oldTime[3]} ` : '';
    return `${hours}${minutes}${oldTime[1] < 12 ? 'AM' : 'PM'}`;
}
